module.exports = __webpack_public_path__ + "static/media/clock.532b1306.png";